import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Card, CardContent } from './ui/Card';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const revealRef = useScrollReveal();
  const testimonials = [{
    quote: 'Spolupráca s nexify-studio.tech zmenila náš pohľad na to, čo je možné. Za 3 mesiace sme mali funkčnú AI platformu.',
    name: 'Ing. Martin Kováč',
    role: 'CTO',
    company: 'DataFlow SK',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Ich PWA riešenie nám ušetrilo 40% nákladov na vývoj mobilnej aplikácie. Kvalita je na úrovni natívnych appiek.',
    name: 'Mgr. Zuzana Horváthová',
    role: 'CEO',
    company: 'MedTech Solutions',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Gemini embeddings integrované do nášho systému zvýšili presnosť vyhľadávania o 85%. Neuveriteľné výsledky.',
    name: 'Bc. Peter Novák',
    role: 'Head of AI',
    company: 'LogiSmart',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=face'
  }];
  return <section ref={revealRef} className="py-36 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-544" data-mp="2ztlyzvpobaex">
      <div className="reveal text-center mb-28" data-id="element-545" data-mp="2c2ymsy8q5ymk">
        <p className="text-xs font-semibold tracking-[0.2em] text-apple-gray uppercase mb-6" data-id="element-546" data-mp="2745edk8aoxt9">
          REFERENCIE
        </p>
        <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight text-apple-black mb-6" data-id="element-547" data-mp="2m1nww4udqes9">
          Čo Hovoria Naši Klienti
        </h2>
        <p className="text-xl text-apple-gray font-light max-w-2xl mx-auto leading-relaxed" data-id="element-548" data-mp="1anglynpdxbm">
          Výsledky hovoria za všetko. Prečítajte si skúsenosti firiem, ktoré už
          využívajú naše PWA a AI riešenia.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-549" data-mp="3dqwevapaopb">
        {testimonials.map((testimonial, index) => <div key={index} className={`reveal reveal-delay-${index + 1}`} data-id="element-550" data-mp="8cagsr9nbsfk" data-mpi={index}>
            <Card className="h-full border-gray-100 rounded-3xl bg-white/80 backdrop-blur-sm shadow-sm card-hover-premium overflow-hidden" data-id="element-551" data-mp="ddzvcgw2uo8e">
              <CardContent className="p-10 flex flex-col h-full relative" data-id="element-552" data-mp="i9yp6k06cyg7">
                {/* Decorative quote icon */}
                <QuoteIcon className="w-10 h-10 text-apple-blue/10 absolute top-6 right-6" data-id="element-553" data-mp="3lsrp3u015orw" />

                <div className="flex gap-1 mb-6" data-id="element-554" data-mp="3qruujfjx9x0e">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current text-amber-400" data-id="element-555" data-mp="3vikxyn8sfpsg" data-mpi={i} />)}
                </div>

                <p className="text-apple-black text-lg leading-relaxed font-light mb-8 flex-grow relative" data-id="element-556" data-mp="2y1cqocbdjrlx">
                  <span className="text-3xl font-bold text-apple-blue/20 leading-none mr-1" data-id="element-557" data-mp="1k75v164qv80t">
                    "
                  </span>
                  {testimonial.quote}
                  <span className="text-3xl font-bold text-apple-blue/20 leading-none ml-1" data-id="element-558" data-mp="1g3g3q8woqcc3">
                    "
                  </span>
                </p>

                <div className="flex items-center gap-4 mt-auto pt-6 border-t border-gray-100" data-id="element-559" data-mp="166bjwfqbasyg">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-md" data-id="element-560" data-mp="119bkgnnywogb" />
                  <div data-id="element-561" data-mp="sg80dwithdcp">
                    <h4 className="font-bold text-apple-black text-sm" data-id="element-562" data-mp="ngvg9jjbykdt">
                      {testimonial.name}
                    </h4>
                    <p className="text-apple-gray text-xs font-light" data-id="element-563" data-mp="igqvvifax5ib">
                      {testimonial.role}, {testimonial.company}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>)}
      </div>
    </section>;
}